module.exports = "\n   textarea { \n    width:100%; \n} "


//////////////////
// WEBPACK FOOTER
// ./src/app/template/password-viewer/password-fields/password-fields.component.css
// module id = ./src/app/template/password-viewer/password-fields/password-fields.component.css
// module chunks = main